import type { FC, ReactNode } from 'react';
import { DefaultLayout } from '@/base/layouts/DefaultLayout';
import type { HeaderPosition } from '../base/layouts/Header';

export const LandingLayout: FC<{
  children: ReactNode;
  hideFooter?: boolean;
  headerPosition?: HeaderPosition;
}> = ({ children, headerPosition = 'smart-sticky', hideFooter = false }) => {
  return (
    <DefaultLayout hideFooter={hideFooter} headerPosition={headerPosition}>
      {children}
    </DefaultLayout>
  );
};
